import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Qual a quantidade mínima de pedido?",
    a: "Nossa quantidade mínima começa em 50 unidades para a maioria dos produtos, podendo chegar a 100 unidades para sacolas TNT. Consulte o produto desejado ou solicite um orçamento personalizado.",
  },
  {
    q: "Qual o prazo de produção?",
    a: "Os prazos variam de 5 a 15 dias úteis dependendo do produto, técnica de personalização e quantidade. Trabalhamos com prazos otimizados e estruturados para entregar com agilidade sem perder qualidade.",
  },
  {
    q: "Vocês entregam para todo o Brasil?",
    a: "Sim. Atendemos todo o território nacional com logística estruturada, transportadoras parceiras e rastreamento completo do pedido até o destino final.",
  },
  {
    q: "Como envio minha arte para personalização?",
    a: "Após a aprovação do orçamento, você envia a arte (preferencialmente vetorizada em .AI, .EPS, .PDF ou .CDR) pelo e-mail ou WhatsApp. Nossa equipe de design finaliza o mockup digital para sua aprovação antes da produção.",
  },
  {
    q: "Posso solicitar orçamento sem compromisso?",
    a: "Sim. Nosso atendimento consultivo é gratuito e sem compromisso. Envie sua necessidade pelo formulário ou WhatsApp e receba uma proposta detalhada em poucas horas.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "Aceitamos PIX (com condições especiais), cartão de débito e cartão de crédito (com possibilidade de parcelamento). Para pedidos corporativos de maior volume, podemos avaliar condições adicionais.",
  },
];

export const FaqSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="mn-section" style={{ background: "var(--mn-cream)" }}>
      <div className="mn-container grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="mn-eyebrow">Dúvidas frequentes</span>
          <h2 className="mn-h-display text-[2.25rem] sm:text-[2.75rem] lg:text-[3rem] mt-4 leading-tight">
            Tudo o que você precisa saber <span style={{ color: "var(--mn-gold)" }}>antes de contratar.</span>
          </h2>
          <p className="mt-5 text-[var(--mn-dark)] leading-relaxed">
            Não encontrou sua dúvida? Fale diretamente com nossa consultoria pelo WhatsApp ou solicite um orçamento.
          </p>
        </div>

        <div className="lg:col-span-7" data-testid="faq-list">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f) => (
              <AccordionItem key={f.q} value={f.q} className="border-b border-[var(--mn-line)]" data-testid={`faq-item-${f.q.slice(0, 24)}`}>
                <AccordionTrigger className="text-left font-serif-display font-bold text-lg text-[var(--mn-black)] hover:text-[var(--mn-gold)] py-6 hover:no-underline data-[state=open]:text-[var(--mn-gold)]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--mn-dark)] leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
